import { DeviceTypes } from '@shared/api/graphql/generated';

import { TEXTS } from './texts';

export const DEVICE_TEXTS: Record<DeviceTypes, string> = {
  [DeviceTypes.AliceSpeaker]: TEXTS.ALICE,
  [DeviceTypes.Android]: TEXTS.ANDROID,
  [DeviceTypes.Androidbox]: TEXTS.ANDROID_BOX,
  [DeviceTypes.BoomSpeaker]: TEXTS.BOOM_SPEAKER,
  [DeviceTypes.Desktop]: TEXTS.DESKTOP,
  [DeviceTypes.Desktopbox]: TEXTS.DESKTOP_BOX,
  [DeviceTypes.Ios]: TEXTS.IOS,
  [DeviceTypes.Musicbox]: TEXTS.DEFAULT,
  [DeviceTypes.Netcore]: TEXTS.DEFAULT,
  [DeviceTypes.Pavo]: TEXTS.DEFAULT,
  [DeviceTypes.Webplayer]: TEXTS.WEB,
};
